import React from 'react';

function CV() {
  return (
    <embed src='/cv/isak-reinholdsson-cv-2024.pdf' style={{ width: '100%', height: '100%' }} ></ embed >
  );
}

export default CV;